import { useMutation, useQueryClient } from '@tanstack/react-query';
import { serviceVendorsClient } from '@/services/petseo.service';
import type { UpdateEmployeeRequest, ServiceVendorId, EmployeeId } from '@/services/api/petseo.client.wrapper';
import { TOAST_MESSAGES, employeeKeys, toast } from '@petseo/shared';

interface UpdateEmployeeParams {
  serviceVendorId: ServiceVendorId;
  serviceVendorEmployeeId: EmployeeId;
  data: UpdateEmployeeRequest;
}

export const useUpdateEmployee = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ serviceVendorId, serviceVendorEmployeeId, data }: UpdateEmployeeParams) => {
      const response = await serviceVendorsClient.putEmployeeEndpoint(data, String(serviceVendorId), String(serviceVendorEmployeeId));
      return response.data;
    },
    onSuccess: (_, { serviceVendorId }) => {
      queryClient.invalidateQueries({ queryKey: employeeKeys.forVendor(serviceVendorId) });
      toast.success(TOAST_MESSAGES.EMPLOYEE_UPDATED);
    },
    onError: () => toast.error(TOAST_MESSAGES.EMPLOYEE_UPDATE_ERROR),
  });
};
